import { render, staticRenderFns } from "./skTabConfirm.vue?vue&type=template&id=340b8ee5&scoped=true"
import script from "./skTabConfirm.vue?vue&type=script&lang=js"
export * from "./skTabConfirm.vue?vue&type=script&lang=js"
import style0 from "./skTabConfirm.vue?vue&type=style&index=0&id=340b8ee5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b8ee5",
  null
  
)

export default component.exports